// Formatted national EXAMPLE numbers, one per ISO country in
// `country-codes.ts` — the phone editor's per-region placeholder. These are
// placeholder strings, not formatting metadata: the package still formats and
// validates real values through the `phone` package (see AGENTS.md), and a
// country absent here (a dissolved territory) falls back to a generic hint.
//
// GENERATED from libphonenumber-js `examples.mobile.json` via
// `getExampleNumber(iso, examples).formatNational()`. Do not hand-edit
// entries; regenerate the table against a newer libphonenumber-js instead.
export const phoneExampleByIso: Record<string, string> = {
  US: "(201) 555-0123",
  AF: "070 123 4567",
  AL: "067 212 3456",
  DZ: "0551 23 45 67",
  AS: "(684) 733-1234",
  AD: "312 345",
  AO: "923 123 456",
  AI: "(264) 235-1234",
  AG: "(268) 464-1234",
  AR: "011 15-2345-6789",
  AM: "077 123456",
  AW: "560 1234",
  AU: "0412 345 678",
  AT: "0664 123456",
  AZ: "040 123 45 67",
  BH: "3600 1234",
  BD: "01812-345678",
  BB: "(246) 250-1234",
  BY: "8 029 491-19-11",
  BE: "0450 00 12 34",
  BZ: "622-1234",
  BJ: "01 95 12 34 56",
  BM: "(441) 370-1234",
  BT: "17 12 34 56",
  BO: "71234567",
  BA: "061 123 456",
  BW: "71 123 456",
  BR: "(11) 96123-4567",
  IO: "380 1234",
  VG: "(284) 300-1234",
  BN: "712 3456",
  BG: "043 012 345",
  BF: "70 12 34 56",
  MM: "09 212 3456",
  BI: "79 56 12 34",
  KH: "091 234 567",
  CM: "6 71 23 45 67",
  CA: "(506) 234-5678",
  CV: "991 12 34",
  KY: "(345) 323-1234",
  CF: "70 01 23 45",
  TD: "63 01 23 45",
  CL: "(2) 2123 4567",
  CN: "131 2345 6789",
  CO: "321 1234567",
  KM: "321 23 45",
  CK: "71 234",
  CR: "8312 3456",
  CI: "01 23 45 6789",
  HR: "092 123 4567",
  CU: "05 1234567",
  CY: "96 123456",
  CZ: "601 123 456",
  CD: "0991 234 567",
  DK: "34 41 23 45",
  DJ: "77 83 10 01",
  DM: "(767) 225-1234",
  DO: "(809) 234-5678",
  EC: "099 123 4567",
  EG: "010 01234567",
  SV: "7012 3456",
  GQ: "222 123 456",
  ER: "07 123 456",
  EE: "5123 4567",
  ET: "091 123 4567",
  FK: "51234",
  FO: "21 12 34",
  FM: "350 1234",
  FJ: "701 2345",
  FI: "041 2345678",
  FR: "06 12 34 56 78",
  GF: "0694 20 12 34",
  PF: "87 12 34 56",
  GA: "06 03 12 34",
  GE: "555 12 34 56",
  DE: "01512 3456789",
  GH: "023 123 4567",
  GI: "57123456",
  GR: "691 234 5678",
  GL: "22 12 34",
  GD: "(473) 403-1234",
  GP: "0690 00 12 34",
  GU: "(671) 300-1234",
  GT: "5123 4567",
  GN: "601 12 34 56",
  GW: "955 012 345",
  GY: "609 1234",
  HT: "34 10 1234",
  HN: "9123-4567",
  HK: "5123 4567",
  HU: "06 20 123 4567",
  IS: "611 1234",
  IN: "081234 56789",
  ID: "0812-345-678",
  IR: "0912 345 6789",
  IQ: "0791 234 5678",
  IE: "085 012 3456",
  IL: "050-234-5678",
  IT: "312 345 6789",
  JM: "(876) 210-1234",
  JP: "090-1234-5678",
  JO: "07 9012 3456",
  KZ: "8 (771) 000 9998",
  KE: "0712 123456",
  KI: "72001234",
  XK: "043 201 234",
  KW: "500 12345",
  KG: "0700 123 456",
  LA: "020 23 123 456",
  LV: "21 234 567",
  LB: "71 123 456",
  LS: "5012 3456",
  LR: "077 012 3456",
  LY: "091-2345678",
  LI: "660 234 567",
  LT: "(0-612) 34567",
  LU: "628 123 456",
  MO: "6612 3456",
  MK: "072 345 678",
  MG: "032 12 345 67",
  MW: "0991 23 45 67",
  MY: "012-345 6789",
  MV: "771-2345",
  ML: "65 01 23 45",
  MT: "9696 1234",
  MH: "235-1234",
  MQ: "0696 20 12 34",
  MR: "22 12 34 56",
  MU: "5251 2345",
  YT: "0639 01 23 45",
  MX: "222 123 4567",
  MD: "0621 12 345",
  MC: "06 12 34 56 78",
  MN: "8812 3456",
  ME: "060 123 456",
  MS: "(664) 492-3456",
  MA: "06 50 12 34 56",
  MZ: "82 123 4567",
  NA: "081 123 4567",
  NR: "555 1234",
  NP: "984-1234567",
  NL: "06 12345678",
  NC: "75.12.34",
  NZ: "021 123 4567",
  NI: "8123 4567",
  NE: "93 12 34 56",
  NG: "0802 123 4567",
  NU: "888 4012",
  NF: "3 81234",
  KP: "0192 123 4567",
  MP: "(670) 234-5678",
  NO: "40 61 23 45",
  OM: "9212 3456",
  PK: "0301 2345678",
  PW: "620 1234",
  PS: "0599 123 456",
  PA: "6123-4567",
  PG: "7012 3456",
  PY: "0961 456789",
  PE: "912 345 678",
  PH: "0905 123 4567",
  PL: "512 345 678",
  PT: "912 345 678",
  PR: "(787) 234-5678",
  QA: "3312 3456",
  CG: "06 123 4567",
  RE: "0692 12 34 56",
  RO: "0712 034 567",
  RU: "8 (912) 345-67-89",
  RW: "0720 123 456",
  BL: "0690 00 12 34",
  SH: "51234",
  KN: "(869) 765-2917",
  MF: "0690 00 12 34",
  PM: "055 12 34",
  VC: "(784) 430-1234",
  WS: "72 12345",
  SM: "66 66 12 12",
  ST: "981 2345",
  SA: "051 234 5678",
  SN: "70 123 45 67",
  RS: "060 1234567",
  SC: "2 510 123",
  SL: "(025) 123456",
  SG: "8123 4567",
  SK: "0912 123 456",
  SI: "031 234 567",
  SB: "74 21234",
  SO: "7 1123456",
  ZA: "071 123 4567",
  KR: "010-2000-0000",
  ES: "612 34 56 78",
  LK: "071 234 5678",
  LC: "(758) 284-5678",
  SD: "091 123 1234",
  SR: "741-2345",
  SZ: "7612 3456",
  SE: "070-123 45 67",
  CH: "078 123 45 67",
  SY: "0944 567 890",
  TW: "0912 345 678",
  TJ: "91 712 3456",
  TZ: "0621 234 567",
  TH: "081 234 5678",
  BS: "(242) 359-1234",
  GM: "301 2345",
  TL: "7721 2345",
  TG: "90 11 23 45",
  TK: "7290",
  TO: "771 5123",
  TT: "(868) 291-1234",
  TN: "20 123 456",
  TR: "0501 234 56 78",
  TM: "8 66 123456",
  TC: "(649) 231-1234",
  TV: "90 1234",
  UG: "0712 345678",
  UA: "050 123 4567",
  AE: "050 123 4567",
  GB: "07400 123456",
  UY: "094 231 234",
  VI: "(340) 642-1234",
  UZ: "91 234 56 78",
  VU: "591 2345",
  VA: "312 345 6789",
  VE: "0412-1234567",
  VN: "0912 345 678",
  WF: "82 12 34",
  YE: "0712 345 678",
  ZM: "095 5123456",
  ZW: "071 234 5678",
};
